<template>
    <DataTable
            :url="api.ACTIONS.USERS"
            :titles="titles"
            :fields-hidden-main="['deleted_at','updated_at','profile_image', 'telegram_username']"
            :fields-hidden-add="['id','deleted_at','created_at','updated_at','roles']"
            :input-types-add="{password: 'password', password_confirmation: 'password'}"
            :fields-extra-add="fieldsExtraAdd"
            :formatter="formatter"
            title="Users"
            :enableEdit="false"
            :actions-extra-main="actionsExtraMain"
            :add-rules="rules"
    />
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    const required = val => (val !== null && val !== undefined) || 'this field is required';
    const email = val => !!val && val.search(/^(\w|-|\.|_)+@(\w|-|\.|_)+\.\w+$/) !== -1 || 'this must be a valid email';
    const past = val => !!val && moment(val).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD') || 'this must be past date';
    const phoneNumber = val => !!val && val.search(/^9\d{8}$/) !== -1 || 'Not A valid phone number !';
    export default {
        name: "Users",
        title: 'Users',
        components: {DataTable},
        computed: {
            rules() {
                return {
                    username: [required, email],
                    gender: [required],
                    first_name: [required],
                    last_name: [required],
                    birthday: [required, past],
                    phone_number: [required, phoneNumber],
                    password: [required]
                }
            },
            fieldsExtraAdd() {
                return {
                    password: 'v-text-field',
                    password_confirmation: 'v-text-field',
                    profile_image: 'choose-image-single',
                    roles: 'choose-role',
                    gender: 'choose-gender',
                    birthday: 'choose-date'
                };
            },
            titles() {
                return {
                    id: '#',
                    username: 'Email',
                    first_name: 'First name',
                    last_name: 'Last name',
                    gender: 'Gender',
                    birthday: 'Birthday',
                    phone_number: 'Phone Number',
                    created_at: "Joined At",
                    profile_image: 'Profile Image',
                    role_id: "Role",
                    password: "Password",
                    password_confirmation: "Confirm Password",
                    roles: 'Roles'
                }
            },
            formatter() {
                return {
                    gender: (value) => value == this.api.CONSTANTS.GENDER.MALE ? "M" : "F",
                    roles: (roles) => {
                        if (roles.length === 0)
                            return "No Roles";
                        return roles.map(({name}) => name).join(",");
                    }
                }
            },
            actionsExtraMain() {
                return {
                    prices: {
                        title: "Profile",
                        icon: 'account_circle',
                        action: (item) =>
                            this.$router.push({
                                name: "UserProfile",
                                params: {"id": item.id}
                            })
                    }
                }
            }
        }
    }
</script>
